import React from 'react';
import './Product.css';

import NextSection from './products/Chatbot-edvora';

import SemanticSearchEngine from './products/SemanticSearchEngine';
import LunarCraterImageEnhancement from './products/LunarcraterImageEnhancement';
import EmotionDetection from './products/EmotionDetection';
import AchievementSection from './products/AchievementSection';

const Product = () => {
  return (
    <div className="product-page" id="projects">
      {/* Header Section with Background Image */}
      <div className="product-header-section">
      </div>
      <LunarCraterImageEnhancement />
      <section id="platform">
        <NextSection />
      </section>

      <SemanticSearchEngine />
      <EmotionDetection />

      <AchievementSection />

    </div>
  );
};

export default Product;
